import {css} from "styled-components";

export type TTypographyKind =
    | "small"
    | "primary"
    | "primary_headline"
    | "primary_bold"
    | "R-10"
    | "R-12"
    | "R-14"
    | "R-16"
    | "R-18"
    | "M-10"
    | "M-12"
    | "M-14"
    | "M-16"
    | "M-18"
    | "M-20"
    | "Sb-10"
    | "Sb-12"
    | "Sb-14"
    | "Sb-16"
    | "Sb-18"
    | "Sb-20"
    | "Sb-22"
    | "Sb-24"
    | "Sb-28"
    | "Sb-30"
    | "BN-10"
    | "BN-16"
    | "BN-18"
    | "BN-24"
    | "BN-28"
    | "BN-32"
    | "BN-40";

interface IProps {
    kind: TTypographyKind;
    weight?: number;
}

export function getTypographyFontStyles({kind, weight}: IProps) {
    if (kind === "small") {
        return css`
            font-family: "Roobert";
            font-size: 10px;
            font-weight: ${() => weight ?? 800};
            line-height: 121%;
        `;
    }

    if (kind === "primary") {
        return css`
            font-family: "Inter";
            font-size: 12px;
            font-weight: ${() => weight ?? 600};
            line-height: 121%;
        `;
    }

    if (kind === "primary_headline") {
        return css`
            font-family: "Montserrat";
            font-size: 12px;
            font-weight: ${() => weight ?? 600};
            line-height: 121%;
        `;
    }

    if (kind === "primary_bold") {
        return css`
            font-family: "Inter";
            font-size: 12px;
            font-weight: ${() => weight ?? 800};
            line-height: 121%;
        `;
    }

    if (kind === "R-10") {
        return css`
            font-family: "Roobert";
            font-style: normal;
            font-weight: 400;
            font-size: 10px;
            line-height: 120%;
            text-align: right;
            letter-spacing: -0.01em;
        `;
    }

    if (kind === "R-12") {
        return css`
            font-family: Roobert;
            font-size: 12px;
            font-weight: 400;
            line-height: 14.4px;
            letter-spacing: -0.01em;
            text-align: left;
        `;
    }

    if (kind === "R-14") {
        return css`
            font-family: Roobert;
            font-size: 14px;
            font-weight: 400;
            line-height: 16.8px;
            letter-spacing: -0.01em;
            text-align: left;
        `;
    }

    if (kind === "R-16") {
        return css`
            font-family: Roobert;
            font-size: 16px;
            font-weight: 400;
            line-height: 19.2px;
            letter-spacing: -0.01em;
            text-align: left;
        `;
    }

    if (kind === "R-18") {
        return css`
            font-family: "Roobert";
            font-style: normal;
            font-weight: 400;
            font-size: 18px;
            line-height: 120%;
            letter-spacing: -0.01em;
        `;
    }

    if (kind === "M-10") {
        return css`
            font-family: Roobert;
            font-size: 10px;
            font-weight: 500;
            line-height: 11px;
        `;
    }

    if (kind === "M-12") {
        return css`
            font-family: Roobert;
            font-size: 12px;
            font-weight: 500;
            line-height: 14.4px;
            text-align: left;
        `;
    }

    if (kind === "M-14") {
        return css`
            font-family: Roobert;
            font-size: 14px;
            font-weight: 500;
            line-height: 15.4px;
            letter-spacing: -0.01em;
            text-align: left;
        `;
    }

    if (kind === "M-16") {
        return css`
            font-family: Roobert;
            font-size: 16px;
            font-weight: 500;
            line-height: 19.2px;
            letter-spacing: -0.01em;
            text-align: left;
        `;
    }

    if (kind === "M-18") {
        return css`
            font-family: "Roobert";
            font-style: normal;
            font-weight: 500;
            font-size: 18px;
            line-height: 120%;
            text-align: center;
            letter-spacing: -0.01em;
        `;
    }

    if (kind === "M-20") {
        return css`
            font-family: Roobert;
            font-size: 20px;
            font-weight: 500;
            line-height: 24px;
            letter-spacing: -0.01em;
            text-align: center;
        `;
    }

    if (kind === "Sb-10") {
        return css`
            font-family: Roobert;
            font-size: 10px;
            font-weight: 600;
            line-height: 12px;
            letter-spacing: 0.13em;
            text-align: left;
        `;
    }

    if (kind === "Sb-12") {
        return css`
            font-family: Roobert;
            font-size: 12px;
            font-weight: 600;
            line-height: 14.4px;
            text-align: left;
        `;
    }

    if (kind === "Sb-14") {
        return css`
            font-family: Roobert;
            font-size: 14px;
            font-weight: 600;
            line-height: 16.8px;
            letter-spacing: -0.01em;
            text-align: left;
        `;
    }

    if (kind === "Sb-16") {
        return css`
            font-family: Roobert;
            font-size: 16px;
            font-weight: 600;
            line-height: 19.2px;
            letter-spacing: -0.01em;
            text-align: left;
        `;
    }

    if (kind === "Sb-18") {
        return css`
            font-family: Roobert;
            font-size: 18px;
            font-weight: 600;
            line-height: 21.6px;
            letter-spacing: -0.01em;
            text-align: left;
        `;
    }

    if (kind === "Sb-20") {
        return css`
            font-family: Roobert;
            font-size: 20px;
            font-weight: 600;
            line-height: 24px;
            letter-spacing: -0.01em;
            text-align: left;
        `;
    }

    if (kind === "Sb-22") {
        return css`
            font-family: Roobert;
            font-size: 22px;
            font-weight: 600;
            line-height: 26.4px;
            letter-spacing: -0.01em;
            text-align: left;
        `;
    }

    if (kind === "Sb-24") {
        return css`
            font-family: Roobert;
            font-size: 24px;
            font-weight: 600;
            line-height: 28.8px;
            letter-spacing: -0.01em;
            text-align: left;
        `;
    }

    if (kind === "Sb-28") {
        return css`
            font-family: Roobert;
            font-size: 28.03px;
            font-weight: 600;
            line-height: 33.64px;
            text-align: center;
        `;
    }

    if (kind === "Sb-30") {
        return css`
            font-family: Roobert;
            font-size: 30px;
            font-weight: 600;
            line-height: 36px;
            letter-spacing: -0.01em;
        `;
    }

    if (kind === "BN-10") {
        return css`
            font-family: "Nebulica";
            font-style: normal;
            font-weight: 600;
            font-size: 10px;
            line-height: 100%;
        `;
    }

    if (kind === "BN-16") {
        return css`
            font-family: "Nebulica";
            font-style: normal;
            font-weight: 600;
            font-size: 16px;
            line-height: 100%;
        `;
    }

    if (kind === "BN-18") {
        return css`
            font-family: "Nebulica";
            font-style: normal;
            font-weight: 700;
            font-size: 18px;
            line-height: 100%;
        `;
    }

    if (kind === "BN-24") {
        return css`
            font-family: "Nebulica";
            font-style: normal;
            font-weight: 700;
            font-size: 24px;
            line-height: 24px;
        `;
    }

    if (kind === "BN-28") {
        return css`
            font-family: "Nebulica";
            font-style: normal;
            font-weight: 700;
            font-size: 28px;
            line-height: 28px;
        `;
    }

    if (kind === "BN-32") {
        return css`
            font-family: "Nebulica";
            font-style: normal;
            font-weight: 700;
            font-size: 32px;
            line-height: 100%;
            display: flex;
            align-items: flex-end;
            text-transform: uppercase;
        `;
    }

    if (kind === "BN-40") {
        return css`
            font-family: "Nebulica";
            font-style: normal;
            font-weight: 700;
            font-size: 40px;
            line-height: 40px;
        `;
    }

    return null;
}
